import React from "react";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { FAQ as FAQ_ITEMS } from "../../data/content";
import { Reveal } from "./Reveal";

export const FAQ = () => {
  return (
    <section id="faq" data-testid="faq" className="bg-white border-t border-[#ece4d7]">
      <div className="max-w-3xl mx-auto px-6 py-20 md:py-28">
        <Reveal className="text-center max-w-2xl mx-auto mb-12 md:mb-16">
          <p className="text-xs tracking-[0.3em] uppercase text-[#b07a63] mb-5">
            Questions fréquentes
          </p>
          <h2 className="font-serif-display font-light text-[#4b2018] text-4xl md:text-5xl">
            Avant de venir
          </h2>
          <p className="mt-5 text-[#4b2018] leading-relaxed">
            Quelques réponses pour préparer sereinement votre visite.
          </p>
        </Reveal>

        <Reveal>
          <Accordion type="single" collapsible className="w-full">
            {FAQ_ITEMS.map((item, i) => (
              <AccordionItem
                key={i}
                value={`faq-${i}`}
                data-testid={`faq-item-${i}`}
                className="border-b border-[#ece4d7]"
              >
                <AccordionTrigger className="font-serif-display text-lg md:text-xl text-[#4b2018] hover:no-underline py-6">
                  {item.q}
                </AccordionTrigger>
                <AccordionContent className="text-[#4b2018] leading-relaxed text-sm md:text-base whitespace-pre-line">
                  {item.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
      </div>
    </section>
  );
};
